import type { Locale } from '@govard/i18n-core';

export const LOCALE_STORAGE_KEY = 'govard.crm.locale';

export function getBrowserStorage(): Storage | undefined {
  if (typeof window === 'undefined') return undefined;
  try {
    return window.localStorage;
  } catch {
    return undefined;
  }
}

export function isLocale(value: unknown): value is Locale {
  return value === 'ru' || value === 'en';
}

export function readStoredLocale(storage: Pick<Storage, 'getItem'> | undefined): Locale {
  if (!storage) return 'ru';
  try {
    const value = storage.getItem(LOCALE_STORAGE_KEY);
    return isLocale(value) ? value : 'ru';
  } catch {
    return 'ru';
  }
}

export function writeStoredLocale(
  storage: Pick<Storage, 'setItem'> | undefined,
  locale: Locale,
): void {
  try {
    const targetStorage = storage ?? getBrowserStorage();
    targetStorage?.setItem(LOCALE_STORAGE_KEY, locale);
  } catch {
    // Storage may be unavailable in privacy mode; locale still works for the tab.
  }
}
